'use strict';

var text = require('@pixi/text');

function getTextView(text$1) {
  if (typeof text$1 === "string" || typeof text$1 === "number") {
    return new text.Text(String(text$1));
  }
  return text$1;
}

exports.getTextView = getTextView;
//# sourceMappingURL=text.js.map
